import BotResponseTreeNode from './BotResponseTreeNode';
import SlotDisplayCondition from './SlotDisplayCondition';

class SendEmailTreeNode {
  recipient: string;

  subject: string;

  content: string;

  attachmentVariableName: string | null;

  nextStep: BotResponseTreeNode | null;

  slotDisplayConditions: SlotDisplayCondition[];

  constructor(
    recipient: string,
    subject: string,
    content: string,
    attachmentVariableName: string | null,
    nextStep: BotResponseTreeNode | null,
    slotDisplayConditions: SlotDisplayCondition[]
  ) {
    this.recipient = recipient;
    this.subject = subject;
    this.content = content;
    this.attachmentVariableName = attachmentVariableName;
    this.nextStep = nextStep;
    this.slotDisplayConditions = slotDisplayConditions;
  }
}

export default SendEmailTreeNode;
